export const SCROLL_TIMEOUT = 500;
export const VISIBLE_PADDING = 300;
export const DEFAULT_CONTAINER_WIDTH = 1024;
export const DEFAULT_SPACING = 16;
export const DEFAULT_ELEMENT_ASPECT_RATIO = 0.95;
const elementAspectRatio = DEFAULT_ELEMENT_ASPECT_RATIO;
export const DEFAULT_BREAKPOINTS = [
    {
        maxWidth: 735,
        elementsPerRow: 1,
        elementAspectRatio
    },
    {
        maxWidth: 1280,
        elementsPerRow: 3,
        elementAspectRatio
    },
    {
        maxWidth: 1536,
        elementsPerRow: 4,
        elementAspectRatio
    },
    {
        maxWidth: 9999,
        elementsPerRow: 5,
        elementAspectRatio
    }
];
export const pageMarginByScreenWidth = {
    480: 68.5,
    1024: 40,
    1280: 40,
    1366: 60,
    1920: 60
};

//# sourceMappingURL=constants.js.map